import React from "react";
import Message from "../components/ds/Message";


export default function Error() {
  return (
    <div id="error">
      <Message type="alert" description="Hubo un error inesperado o la URL a la que intentas acceder no existe." />
    </div>
  ) 
}